import axios from 'axios'
import globalConfig, {getApiBaseUrl} from '@/config/config'
import {getToken, setToken} from '@/libs/util'
import {Dialog} from 'vant';
import {Decrypt} from '@/libs/crypto'
import store from '../store'
import {reportError} from "@/api/report";

// 内部配置
const insideConfig = {
    baseURL: getApiBaseUrl(),
    withCredentials: false,
    headers: {
        'authorization-token': getToken(),
        'sid': globalConfig.sid
    }
}

// 创建实例
const instance = axios.create(insideConfig)

// 请求拦截
instance.interceptors.request.use(config => {

    return config
}, error => {
    return Promise.reject(error)
})

// 响应拦截
instance.interceptors.response.use(res => {
    if (res.data.response) {
        let responseData = res.data.response;
        if (res.data.isEncrypted) {
            responseData = Decrypt(responseData);
        }
        if (typeof (responseData) === 'string' && responseData.includes('https://cos.duopei.top')) {
            responseData = responseData.replace(/https:\/\/cos.duopei.top/g, 'http://cos.duopei.feiniaowangluo.com')
        }
        if (typeof (responseData) === 'string' && responseData.includes('http://cos.duopei.ygcsc.com')) {
            responseData = responseData.replace(/http:\/\/cos.duopei.ygcsc.com/g, 'http://cos.duopei.feiniaowangluo.com')
        }
        if (typeof (responseData) === 'string' && responseData.includes('http://cos.peipei.featnet.com')) {
            responseData = responseData.replace(/http:\/\/cos.peipei.featnet.com/g, 'http://cos.duopei.feiniaowangluo.com')
        }
        if (store.state.label) {
            if (store.state.label.clerkLabel != '店员') {
                responseData = responseData.replace(/店员/g,store.state.label.clerkLabel);
            }
            if (store.state.label.salaryLabel != '工资') {
                responseData = responseData.replace(/工资/g,store.state.label.salaryLabel);
            }
        }
        res.data = JSON.parse(responseData)
    }
    const data = res.data;
    const code = typeof data.code === 'undefined' ? 0 : data.code;
    // const status = res.status;
    const msg = data.msg

    data.code = code
    if (msg === 'undefined') {
        data.msg = code == 0 ? 'success' : '网络异常，请稍后再试';
    }

    return res;
}, error => {
    if (!error.response || error.response.headers['system-token-status'] != 'invalid') {
        if(error.config && error.config.url && error.config.url.startsWith('/global/getV2')){
            reportError(JSON.stringify({message:error.message,baseUrl: insideConfig.baseURL}))
        }
    }
    if (error.response && error.response.data.response) {
        let responseData = error.response.data.response;
        if (error.response.data.isEncrypted) {
            responseData = Decrypt(responseData);
        }
        error.response.data = JSON.parse(responseData)
    }

    if (error.response && error.response.data && error.response.data.code != null) {
        if (error.response.headers['system-token-status'] == 'invalid'
        && !error.response.config.url.endsWith('/s/c/agreement/163/getLast')) {
            setToken('')
            // alert('token已失效，请刷新重试')
            window.location.reload()
        }

        const data = error.response.data;
        return {
            data: {
                code: data.code,
                msg: data.msg
            },
            error: error
        };
    } else {
        const status = error.response && error.response.status;
        return {
            data: {
                code: -999,
                msg: status != null ? '状态：' + status : error.message
            },
            error: error
        };
    }
})

export default instance;
